import classNames from 'classnames';
import { useInstantSearch } from 'react-instantsearch-core';
import AnimationFadeLazy from '../animation-fade-lazy/animation-fade-lazy';

/* eslint-disable-next-line */
export interface SearchNoResultsProps {
    mode?: 'light' | 'dark';
}

export function SearchNoResults(props: SearchNoResultsProps) {
    const { mode = 'light' } = props;
    const { indexUiState } = useInstantSearch();

    const textColor = classNames({
        'text-gray-900': mode === 'light',
        'text-white': mode === 'dark',
    });

    return (
        <AnimationFadeLazy className="mt-16">
            <p className={`${textColor} h3`}>
                No results for <q>{indexUiState.query}</q>.
            </p>
        </AnimationFadeLazy>
    );
}

export default SearchNoResults;
